import { ClassProvider, Inject, Injectable } from '@angular/core';

import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

import { DATEPICKER_TRANSLATION, DatepickerTranslation } from '@hdms/shared/ui-core';

@Injectable()
class DateTranslationService implements DatepickerTranslation {
  weekdayShort = [];
  monthShort = [];
  monthFull = [];
  ariaCalendar = this.i18NextService.t('common.label.button.openCalendar');
  ariaClear = this.i18NextService.t('common.label.button.clear');

  constructor(@Inject(I18NEXT_SERVICE) private readonly i18NextService: ITranslationService) {
    this.weekdayShort = Object.values(i18NextService.t('date.weekdayShort', { returnObjects: true }));
    this.monthFull = Object.values(i18NextService.t('date.monthFull', { returnObjects: true }));
    this.monthShort = Object.values(i18NextService.t('date.monthShort', { returnObjects: true }));
  }
}

export const DATE_TRANSLATION_PROVIDER: ClassProvider = {
  provide: DATEPICKER_TRANSLATION,
  useClass: DateTranslationService
};
